/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { toJS } from 'mobx';
import * as React from 'react';

import { ILxsAnonymousDeliveryData, ILxsAnonymousDeliveryDataViewProps } from './lxs-anonymous-delivery.data';
import { ILxsAnonymousDeliveryProps } from './lxs-anonymous-delivery.props.autogenerated';

export interface ILxsAnonymousDeliveryViewProps extends ILxsAnonymousDeliveryDataViewProps {}

interface ILxsAnonymousDeliveryState {
    isLoading: boolean;
}

/**
 *
 * LxsAnonymousDelivery component
 * @extends {React.PureComponent<ILxsAnonymousDeliveryProps<ILxsAnonymousDeliveryData>>}
 */
class LxsAnonymousDelivery extends React.PureComponent<ILxsAnonymousDeliveryProps<ILxsAnonymousDeliveryData>, ILxsAnonymousDeliveryState> {
    constructor(props: ILxsAnonymousDeliveryProps<ILxsAnonymousDeliveryData>) {
        super(props);
        this.state = { isLoading: true };
    }

    public async componentDidMount(): Promise<void> {
        await this.props.data.localizationState;
        this.setState({ isLoading: false });
    }

    public render(): JSX.Element | null {
        const localizationState = toJS(this.props.data.localizationState?.result);

        return this.props.renderView({ ...this.props, isLoading: this.state.isLoading, localizationState });
    }
}

export default LxsAnonymousDelivery;
